import {
  createSlice,
  createSelector,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { API_ENDPOINT_V1 } from "../../constants";

export const country = createAsyncThunk("country", async () => {
  try {
    const countryResponse = await fetch(`${API_ENDPOINT_V1}countries`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    const countryData = await countryResponse.json();
    return countryData;
  } catch (error) {
    throw new Error(
      `Errore durante la richiesta dei dati dell'utente: ${error.message}`
    );
  }
});

export const province = createAsyncThunk("province", async ({ country }) => {
  try {
    const provinceResponse = await fetch(
      `${API_ENDPOINT_V1}countries/${country}/provinces`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }
    );

    const provinceData = await provinceResponse.json();
    return provinceData;
  } catch (error) {
    throw new Error(
      `Errore durante la richiesta dei dati dell'utente: ${error.message}`
    );
  }
});

export const city = createAsyncThunk("city", async ({ country, province }) => {
  try {
    const cityResponse = await fetch(
      `${API_ENDPOINT_V1}countries/${country}/provinces/${province}/cities`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }
    );

    const cityData = await cityResponse.json();
    return cityData;
  } catch (error) {
    throw new Error(
      `Errore durante la richiesta dei dati dell'utente: ${error.message}`
    );
  }
});

const addressSlice = createSlice({
  name: "Address",
  initialState: {
    isLoading: false,
    isError: false,
    country: null,
    province: null,
    city: null,
  },
  reducers: {
    addItem: (state, action) => {
      state.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(country.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(country.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.country = action.payload;
      })
      .addCase(country.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(province.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(province.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.province = action.payload;
      })
      .addCase(province.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })
      .addCase(city.pending, (state, action) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(city.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.city = action.payload;
      })
      .addCase(city.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});

export const getItemsSelector = createSelector(
  (state) => state.address,
  (state) => state
);

export const { addItem } = addressSlice.actions;

export default addressSlice.reducer;
